"use client";

import { useEffect, useState } from 'react';
import Link from 'next/link';
import { motion, AnimatePresence } from 'framer-motion';

const ANNOUNCEMENTS = [
  { text: 'Earn Reward Points with every shop!', link: '/rewards', color: 'bg-[#9A2643]' },
  { text: 'Free Nationwide delivery over ₦250,000', link: '/shipping', color: 'bg-black' },
  { text: 'Open a TRADE ACCOUNT today', link: '/trade-account', color: 'bg-[#9A2643]' },
  { text: 'Event Planning Services Available', link: '/event-planning', color: 'bg-black' },
];

export default function AnnouncementBar() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const timer = setInterval(() => {
      // Start fade out
      setIsVisible(false);
      
      // After fade out, change message and fade in
      setTimeout(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % ANNOUNCEMENTS.length);
        setIsVisible(true);
      }, 300); // Half of the transition duration
      
    }, 5000); // Change message every 5 seconds

    return () => clearInterval(timer);
  }, []);

  const currentAnnouncement = ANNOUNCEMENTS[currentIndex];

  return (
    <div className={`w-full h-8 md:h-10 overflow-hidden transition-colors duration-500 ${currentAnnouncement.color}`}>
      <AnimatePresence mode="wait">
        {isVisible && (
          <motion.div
            key={currentIndex}
            initial={{ y: -30, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: 30, opacity: 0 }}
            transition={{ duration: 0.3 }}
            className="h-full flex items-center justify-center"
          >
            <Link 
              href={currentAnnouncement.link} 
              className="text-white text-xs md:text-sm font-medium hover:underline"
            >
              {currentAnnouncement.text}
            </Link>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
